import { ORDER_STATUS_LABEL, type OrderStatusKey } from '@garlic/shared';
import { Badge, cx } from '../ui/primitives';

const tone: Record<OrderStatusKey, 'neutral' | 'warning' | 'success' | 'brand' | 'danger'> = {
  RECEIVED: 'brand',
  IN_PREPARATION: 'warning',
  READY: 'success',
  SENT: 'success',
  DELIVERED: 'neutral',
  CANCELLED: 'danger',
};

export function OrderStatusBadge({ status }: { status: string }) {
  const s = status as OrderStatusKey;
  return <Badge tone={tone[s] ?? 'neutral'} dot>{ORDER_STATUS_LABEL[s] ?? status}</Badge>;
}

/**
 * Linha do tempo simples: recebido → em preparo → pronto → entregue. Setor só com impressora (sem tela para
 * marcar as etapas): recebido → enviado para o preparo.
 */
export function OrderProgress({ status }: { status: string }) {
  const steps: OrderStatusKey[] = status === 'SENT' ? ['RECEIVED', 'SENT'] : ['RECEIVED', 'IN_PREPARATION', 'READY', 'DELIVERED'];
  if (status === 'CANCELLED') return null;
  const idx = steps.indexOf(status as OrderStatusKey);
  return (
    <ol className={cx('mt-3 grid gap-1.5', steps.length === 2 ? 'grid-cols-2' : 'grid-cols-4')} aria-label={`Andamento: ${ORDER_STATUS_LABEL[status as OrderStatusKey]}`}>
      {steps.map((s, i) => (
        <li key={s} className="text-center">
          <div className={`h-1.5 rounded-full ${i <= idx ? 'bg-[var(--brand)]' : 'bg-line'}`} />
          <span className={`mt-1 block text-[10px] ${i <= idx ? 'font-medium text-ink' : 'text-ink-3'}`}>{ORDER_STATUS_LABEL[s]}</span>
        </li>
      ))}
    </ol>
  );
}
